import React, { lazy, Suspense } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const MainSlick = ({
  dots,
  infinite,
  speed,
  autoplay,
  autoplaySpeed,
  slidesToShow,
  slidesToScroll,
  centerMode,
  nextArrow,
  prevArrow,
  tabletSlidesToShow,
  tabletSlidesToScroll,
  mobileSlidesToShow,
  mobileSlidesToScroll,
  cssEase,
  fade,
  data
}) => {
  const setting = {
    dots: dots,     // 슬라이드 밑에 점 보이게
    infinite: infinite, // 무한으로 반복
    speed: speed,     // 넘기는 속도
    autoplay: autoplay, // 자동으로 넘김
    autoplaySpeed: autoplaySpeed, //자동으로 넘어가는 속도
    slidesToShow: slidesToShow,    // 스크린에 보여지는 슬라이드 개수
    slidesToScroll: slidesToScroll,  // n장씩 뒤로 넘어가게 함
    // centerMode: true,   // 중앙정렬
    // centerPadding: '0px', // 0px 하면 슬라이드 끝쪽 이미지가 안잘림
    nextArrow: <></>, // 이전 화살표
    prevArrow: <></>, // 다음 화살표 
    cssEase: cssEase,
    fade: fade,
    responsive: [ // 반응형 웹 구현 옵션
      {
        breakpoint: 1024, //화면 사이즈 960px
        settings: {
          //위에 옵션이 디폴트 , 여기에 추가하면 그걸로 변경
          slidesToShow: tabletSlidesToShow,
          slidesToScroll: tabletSlidesToScroll
        }
      },
      {
        breakpoint: 480, //화면 사이즈 768px
        settings: {
          //위에 옵션이 디폴트 , 여기에 추가하면 그걸로 변경
          slidesToShow: mobileSlidesToShow,
          slidesToScroll: mobileSlidesToScroll
        }
      }
    ]
  }

  return (
    <Slider {...setting}>
      {data?.map((el, idx) =>
        <div key={idx} className={`visual${idx + 1} v_item`}><Suspense><img src={el} alt='' loading='lazy' decoding='async' /></Suspense></div>
      )}
    </Slider>
  )
}

export default MainSlick
